export default {
    NO_DECIMAL: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 0
    },

    NO_DECIMAL_NOSEP: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 0
    },

    NO_DECIMAL_PAD_2_ZEROS: {
        minimumIntegerDigits: 2,
        maximumIntegerDigits: 2,
        maximumFractionDigits: 0
    },

    PRECISION1: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    },

    PRECISION1_PAD_2_ZEROS: {
        useGrouping: true,
        minimumIntegerDigits: 2,
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    },

    PRECISION1_NOSEP: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    },

    PRECISION1_NOSEP_NOZERO: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 1,
        minimumFractionDigits: 0
    },

    PRECISION1_NOZERO: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 1,
        minimumFractionDigits: 0
    },

    PRECISION2: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    },

    PRECISION2_NOSEP: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    },

    PRECISION3: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 3,
        minimumFractionDigits: 3
    },

    PRECISION3_NOSEP: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 3,
        minimumFractionDigits: 3
    },

    PRECISION3_NOSEP_NOZERO: {
        useGrouping: false,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 3,
        minimumFractionDigits: 0
    },

    PRECISION_EXTENDED: {
        useGrouping: true,
        minimumIntegerDigits: 1,
        maximumFractionDigits: 8,
        minimumFractionDigits: 8
    },

    FOUR_DIGITS: {
        useGrouping: false,
        minimumIntegerDigits: 4,
        maximumIntegerDigits: 4
    },

    TWO_DIGITS: {
        minimumIntegerDigits: 2,
        maximumIntegerDigits: 2,
        maximumFractionDigits: 0
    },

    ONE_OR_TWO_DIGITS: {
        minimumIntegerDigits: 1,
        maximumIntegerDigits: 2,
        maximumFractionDigits: 0
    }
};
